/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import {Button} from '@insticator/insticator-ui'; // iui-material
import ActionButtons from '../../actionbuttons';
// styles
import injectSheet from 'react-jss';
import styles from './configcontroller_styles';


/* ========== ~~~~~~~~~~ EXPANDABLE SECTION - CONFIG CONTROLLER ~~~~~~~~~~ ========== */
const ConfigController = (props) => {
  const {
    title,
    description,
    descriptionClass,
    handleCancel,
    handleSave,
    handleToggle,
    isOpened,
    isChanged,
    isLoading,
    isDownloading,
    configTitle,
    cancelTitle,
    saveTitle,
    handleDownload,
    downloadTitle,
    isProcessing,
    disableSave,
    disabled
  } = props;

  return (
    <div className={`configcontroller ${props.classes.configcontroller} ${props.className} header controls disabled-${disabled}`}>
      <h2 className='title'>
        {title}
      </h2>

      {!isOpened && <div className={descriptionClass ? descriptionClass : 'description'}>{description}</div>}

      <div>
        {isOpened && <ActionButtons
          handleCancel={handleCancel}
          handleSave={handleSave}
          isChanged={isChanged}
          isLoading={isLoading}
          cancelTitle={cancelTitle}
          saveTitle={saveTitle}
          handleDownload={handleDownload}
          downloadTitle={downloadTitle}
          isDownloading={isDownloading}
          isProcessing={isProcessing}
          disableSave={disableSave}
        />}
        {!isOpened && <Button
          variant={'system'}
          text={configTitle ? configTitle : 'Configure'}
          type={'action'}
          handleClick={handleToggle}
          disabled={disabled}
        />}
      </div>
    </div>
  )
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ConfigController);
